import { Module } from 'vuex';
import { PrintFrameState, RootState } from '../types';

const SET_DELAYED_PRINTING = 'SET_DELAYED_PRINTING';
const SET_PRINT_SOURCE = 'SET_PRINT_SOURCE';

export const PrintFrameActionKeys = {
	setDelayedPrinting: 'setDelayedPrinting',
	print: 'print',
	cleanup: 'cleanup',
};

export const PrintFrameGetterKeys = {
	delayedPrinting: 'delayedPrinting',
	printSource: 'printSource',
	mimeType: 'mimeType',
};

const store: Module<PrintFrameState, RootState> = {
	namespaced: true,
	state: {
		delayedPrinting: false,
		printSource: '',
		mimeType: '',
	},
	getters: {
		[PrintFrameGetterKeys.delayedPrinting]: state => state.delayedPrinting,
		[PrintFrameGetterKeys.printSource]: state => state.printSource,
		[PrintFrameGetterKeys.mimeType]: state => state.mimeType,
	},
	actions: {
		async [PrintFrameActionKeys.setDelayedPrinting](
			{ commit },
			params: { delayedPrinting: boolean },
		) {
			commit(SET_DELAYED_PRINTING, {
				delayedPrinting: params.delayedPrinting,
			});
		},
		async [PrintFrameActionKeys.print](
			{ commit },
			params: { data: string; mime: string },
		) {
			commit(SET_PRINT_SOURCE, {
				printSource: params.data,
				mimeType: params.mime,
			});
		},
		async [PrintFrameActionKeys.cleanup]({ commit }) {
			commit(SET_PRINT_SOURCE, {
				printSource: '',
				mimeType: '',
			});
		},
	},
	mutations: {
		[SET_DELAYED_PRINTING](state, { delayedPrinting }) {
			state.delayedPrinting = delayedPrinting;
		},
		[SET_PRINT_SOURCE](state, { printSource, mimeType }) {
			state.printSource = printSource;
			state.mimeType = mimeType;
		},
	},
};

export default store;
